import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import JudgeCalibrationTab from "@/components/admin/modelCurrency/JudgeCalibrationTab";
import ModelsTab from "@/components/admin/modelCurrency/ModelsTab";

/** Which AI model each feature uses, newer models waiting to be tested, and judge calibration. */
const AdminModelCurrency = () => {
  const navigate = useNavigate();
  return (
    <div className="mx-auto max-w-6xl space-y-6 px-4 py-6">
      <header className="flex flex-wrap items-start justify-between gap-4">
        <div className="min-w-0 space-y-1">
          <h1 className="text-2xl font-semibold tracking-tight">Model Currency</h1>
          <p className="max-w-2xl text-sm text-muted-foreground">
            Keep each AI feature on a current model: see what is in use, review newer models that
            have been tested, and check that the AI judge agrees with a human.
          </p>
        </div>
        <Button variant="ghost" size="sm" onClick={() => navigate("/recruit-admin/dashboard")}>
          <ArrowLeft className="mr-1 h-4 w-4" aria-hidden="true" />
          Back to Dashboard
        </Button>
      </header>
      <Tabs defaultValue="models">
        <TabsList>
          <TabsTrigger value="models">Models</TabsTrigger>
          <TabsTrigger value="calibration">Judge calibration</TabsTrigger>
        </TabsList>
        <TabsContent value="models" className="mt-6">
          <ModelsTab />
        </TabsContent>
        <TabsContent value="calibration" className="mt-6">
          <JudgeCalibrationTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AdminModelCurrency;
